import { useQuery } from '@apollo/react-hooks';
import { useSessionData } from '@confluence/session-data';
import { fg } from '@confluence/feature-gating';

import { GetUserStateQuery } from '../graphql/GetUserStateQuery.graphql';
import type { GetUserState } from '../graphql/__types__/GetUserStateQuery';

export const useUserState = () => {
	const { userId } = useSessionData();

	const {
		data: userStateData,
		loading: isLoading,
		error: userStateDataError,
	} = useQuery<GetUserState>(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		GetUserStateQuery,
		{
			skip: !userId && fg('cconfluence_frontend_get_user_state_query_id_check'),
		},
	);

	const hasJira = userStateData?.tenantContext?.licensedProducts.some(
		(product) =>
			product.productKey.toLowerCase().includes('jira-software') &&
			product.licenseStatus === 'ACTIVE',
	);

	const isSiteAdmin = userStateData?.isSiteAdmin;

	return {
		hasJira,
		isSiteAdmin,
		isLoading,
		userStateDataError,
	};
};
